import type { FunnelReport } from "@/api";

function esc(value: string | number | null | undefined): string {
  const s = value == null ? "" : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Per-option response export, one row per (question, answer). */
export function buildResponsesCsv(report: FunnelReport): string {
  const lines = [
    "question_id,question_label,answer_id,answer_label,count,pct_of_answered,pct_of_started,viewed,answered,exits,drop_off_pct",
  ];
  for (const step of report.steps) {
    if (step.responses.length === 0) {
      lines.push(
        [
          esc(step.question_id), esc(step.label), "", "", "", "", "",
          esc(step.viewed), esc(step.answered), esc(step.exits), esc(step.drop_off_pct),
        ].join(","),
      );
      continue;
    }
    for (const r of step.responses) {
      lines.push(
        [
          esc(step.question_id), esc(step.label), esc(r.answer_id), esc(r.label),
          esc(r.count), esc(r.pct_of_answered), esc(r.pct_of_started),
          esc(step.viewed), esc(step.answered), esc(step.exits), esc(step.drop_off_pct),
        ].join(","),
      );
    }
  }
  return lines.join("\n") + "\n";
}
